import { type DocumentDetailsVersion } from "~/api/types";
import { DocumentVersionStatus } from "~/config/types";
import { useUserContext } from "~/hooks/useUserContext";

export const useSpeEditPermissions = (version: DocumentDetailsVersion) => {
  const { user } = useUserContext();

  const isSpeUserWithoutSso = user.isUsingSpe && !user.isSsoEnabled;

  // For customers that use SPE, disable the action for draft versions if the user has no write permissions
  // This is because SPE permissions are currently more coarse-grained
  const canNotEditSpeDraftFile =
    user.isUsingSpe &&
    version.status === DocumentVersionStatus.draft &&
    !version.permissions.canWrite;

  return { isSpeUserWithoutSso, canNotEditSpeDraftFile };
};
